import Ls from 'assets/services/ls'
export default {

    verifyEmail(token, email) {
        return axios.post(APIURL + '/verify_email', {token, email});
    },
    
    resendVerificationEmail(email) {
        return axios.post(APIURL + '/verify_email_resend', {email});
    },
    
    checkBrowser() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if (msie > 0) // If Internet Explorer, return version number
        {
            alert('Warning - you\'re useing Internet Explorer. Our platform is not supported on IE, and you should update it to Edge as soon as possible!');
            console.log(' IE ' + parseInt(ua.substring(msie + 5, ua.indexOf(".", msie))) + ' detected, aborting');
            return false;
        }
        else  // If another browser, return 0
        {
            console.log("Checking browser... \r\nBrowser is not IE - All good!\r\n### CTR Application ready ###");
            return true;
        }
        return true;        
    },

    setSettings() {
        return axios.get(APIURL + '/settings').then(response => {
            if (typeof (response.data) === 'object') {
                Object.keys(response.data).forEach(function (k) {
                    sessionStorage.setItem('settings.' + k, response.data[k]);
                });
                if(response.data.logo_url) {
                    this.setLogo();
                }
            }
        }).catch(error => {
            console.log('Error', error.message);
        });
    },

    getSetting(key) {
        return sessionStorage.getItem('settings.' + key);
    },

    login(email, password) {
        return axios.post(APIURL + '/login', { email, password }).then((resp) => {
            if (resp.data.access_token) {
                Ls.remove('access_key');
                
                Ls.set('access_key', resp.data.access_token);
                this.getAvatar();
                return true;
            }
        });
    },

    logout() {
        Ls.remove('access_key');
        Ls.remove('auth.user');
        return axios.post(APIURL + '/logout');
    },

    check() {
        return axios.post(APIURL + '/me').then(response =>  {
            Ls.set('auth.user.name', response.data.first_name + ' ' + response.data.last_name);
            Ls.set('auth.user.email', response.data.email);
            Ls.set('auth.user.credits', response.data.credits);
            Ls.set('auth.user.vat_reversed', response.data.vat_reversed);
            var auth = !!response.data.authenticated;
            return !!response.data.authenticated;
        }).catch(error => {
            console.log('Error', error.message);
        });
    },

    getAvatar() {
        return axios.get(APIURL + '/me/avatar', {responseType: 'arraybuffer'}).then(response =>  {
            var avt = "data:image/jpg;base64," + new Buffer(response.data, "binary").toString("base64");
            Ls.set('auth.user.avatar', avt);
        }).catch(error => {
            console.log('Error', error.message);
            Ls.remove('auth.user.avatar');
        });
    },

    getLogo() {
        return '../assets/images/re-logo-black-200.png';
        if(Ls.get('opts.logo')) {
            return Ls.get('opts.logo');
        }
        return axios.get(APIURL + '/settings/logo', {responseType: 'arraybuffer'}).then(response =>  {
            var avt = "data:image/png;base64," + new Buffer(response.data, "binary").toString("base64");
            Ls.set('opts.logo', avt);
        }).catch(error => {
            console.log('Error', error.message);
            Ls.remove('opts.logo');
        });
    },

    resetPasswordRequest(email) {
        let return_url = window.location.origin + '/password-reset';
        return axios.post(APIURL + '/password/request-reset', {email: email, return_url: return_url});
    },

    passwordReset(email, password, token) {
        return axios.post(APIURL + '/password/reset', {email, password, token});
    },

    register(customer) {
        return axios.post(APIURL + '/register', { customer });
    },

    getUser() {
        return axios.post(APIURL + '/me');
    },

    getTuningTypes() {
        return axios.get(APIURL + '/products?type=tuningtype');
    },

    getVehicleTypes() {
        return axios.get(APIURL + '/vehicledata/types');
    },

    getBrands(type) {
        return axios.get(APIURL + '/vehicledata/brands?type=' +  type );
    },

    getBrandImage(brandId) {
        return axios.get(APIURL + '/vehicledata/brands/' + brandId + '/image', {
            responseType: 'arraybuffer'
        });
    },

    getSeries(brand_id) {
        return axios.get(APIURL + '/vehicledata/series?brand_id=' + brand_id);
    },

    getSerieImage(serieId) {
        return axios.get(APIURL + '/vehicledata/series/' + serieId + '/image', {
            responseType: 'arraybuffer'
        });
    },

    getBuilds(serie_id) {
        return axios.get(APIURL + '/vehicledata/builds?serie_id=' + serie_id);
    },

    getEngines(build_id) {
        return axios.get(APIURL + '/vehicledata/engines?build_id=' + build_id);
    },

    getEcuBrands() {
        return axios.get(APIURL + '/vehicledata/ecus/brands');
    },

    getEcuModels(brand_id) {
        return axios.get(APIURL + '/vehicledata/ecus/models?brand_id=' + brand_id);
    },

    getEcuTypes(model_id) {
        return axios.get(APIURL + '/vehicledata/ecus/types?model_id=' + model_id);
    },

    getEcusByEcuBrand(ecu_brand_name) {
        return axios.get(APIURL + '/vehicledata/ecus/types/' + ecu_brand_name);
    },

    getProducts(category) {
        return axios.get(APIURL + '/products?type=' + category);
    },

    getCredit(creditId) {
        return axios.get(APIURL + '/credits/' + creditId);
    },

    getTuningtools() {
        return axios.get(APIURL + '/vehicledata/tuningtools');
    },

    createPayment(product_id, selectedProducts = null) {
        let return_url = window.location.origin + '/portal/transactions/verify';
        return axios.post(APIURL + '/transactions/create', { product_id: product_id, products: selectedProducts, return_url: return_url });
    },

    verifyTransaction(code, payer_id = null) {
        if(null !== payer_id) {
            return axios.post(APIURL + '/transactions/verify?code=' + code + '&payer_id=' + payer_id);
        } else {
            return axios.post(APIURL + '/transactions/verify?code=' + code);
        }
    },

    getInvoice(transactionId) {
        return axios.get(APIURL + '/transactions/' + transactionId + '/invoice',
            {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/pdf'
                }
            });
    },

    getTicket(ticketId) {
        return axios.get(APIURL + '/tickets/' + ticketId + '/edit');
    },

    createTicket(data) {
        return axios.post(APIURL + '/tickets', data);
    },

    sendTicketReply(ticketId, data) {
        return axios.post(APIURL + '/tickets/' + ticketId + '/reply', data);
    },

    deleteTicket(ticketId) {
        return axios.delete(APIURL + '/tickets/' + ticketId);
    },

    downloadFile(fileId, filename = null) {

        if (filename != null) {
            return axios.get(APIURL + '/files/' + fileId + '/download/' + filename,
                {
                    responseType: 'arraybuffer',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
        } else {
            return axios.get(APIURL + '/files/' + fileId + '/download',
                {
                    responseType: 'arraybuffer',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
        }
    },

    downloadTicketFile(ticketId, filename = null) {
        if (filename != null) {
            return axios.get(APIURL + '/tickets/' + ticketId + '/download/' + filename,
                {
                    responseType: 'arraybuffer',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
        } else {
            return axios.get(APIURL + '/tickets/' + ticketId + '/download',
                {
                    responseType: 'arraybuffer',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
        }
    },

    processUpload(data) {
        return axios.post(APIURL + '/files/process', data);
    },

    updateProfile(data) {
        return axios.post(APIURL + '/profile', data);
    },

    getTermsConditions() {
        return axios.get(APIURL + '/terms');
    },

    getFileList() {
        return axios.get(APIURL + '/files');
    }



}


// WEBPACK FOOTER //
// ./src/assets/services/webservice.js